<div class="clearfix">
  @for (type of orderArray; track type) {
    @if (selects[type].visible) {
      <select
        class="form-control"
        [(ngModel)]="selects[type].value"
        (change)="onChange($event)"
        [disabled]="selects[type].disabled"
        (blur)="onTouched($event)"
      >
        @for (option of selects[type].options; track option.value) {
          <option [ngValue]="option.value" [disabled]="option.disabled">
            {{ option.name }}
          </option>
        }
      </select>
    }
  }
</div>
